<template>
<div>
    <div class="columns">
        <div class="column is-3">
            <p class="subtitle" v-if="cities">Chapters <strong>({{cities.length}}) </strong></p>
            <div class="box" style="height:110%;"> <a class="button is-warning full-width-button mb-1" @click="openAddchapterDialog">
                    <span class="icon is-small">
                        <i class="fas fa-plus"></i>
                    </span>
                    <span>Add Module</span>
                </a>
                <b-field expanded>
                    <b-input v-model="searchName" type="search" icon="search" :disabled="!cities || !cities.length" placeholder="Search Chapters "></b-input>
                </b-field>
                <p v-if="isLoading">Loading chapters...</p>
                <div class="chapter-sidebar" v-if="!isLoading">
                    <div v-for="chapter in filterBy(cities, searchName)" :key="chapter.docId" class="card cgapterss" :class="{'is-active': ischapterSelected(chapter)}">
                        <div @click="changechapterSelected(chapter)" class="card-content" style="cursor:pointer;">
                            <div class="chapter-container">

                                <p> <i class="fas fa-book" aria-hidden="true"></i> &ensp; {{chapter.title}}</p>
                                <!--   <div>
                                    <a class="button is-small is-warning " @click="changechapterSelected(chapter)">
                                        <span class="icon is-small">
                                            <i class="fas fa-chevron-right"></i>
                                        </span>
                                    </a>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="column">
            <p class="subtitle" v-if="!chapterSelected">No Module selected</p>
            <p v-if="!chapterSelected">Please select a module.</p>

            <div>
                <div class="subtitle" v-if="chapterSelected"><strong>{{chapterSelected.title}}</strong>

                    &nbsp;
                    <i style="cursor:pointer" @click="openAddchapterDialog(chapterSelected)" class="fas fa-pencil-alt"></i>

                </div>

            </div>

            <div v-if="chapterSelected">

                <!-- <span class="tag is-success " v-if="chapterSelected.configs.active == true"> Online</span>
          <div class="tag is-danger" v-else>Offline</div> -->
            </div>

            <div v-if="chapterSelected">
                <div class="box" style="height:70vh;margin-top : 1.5rem;">
                    <div class="columns">
                        <div class="column is-8">
                            <b-field expanded>
                                <b-input v-model="searchName" type="search" icon="search" :disabled="!cities || !cities.length" placeholder="Search Files"></b-input>
                            </b-field>
                        </div>
                        <div class="column is-4">
                            <b-button expanded type="is-warning" @click="fileModal">
                                Upload Files
                            </b-button>
                        </div>
                    </div>

                    <div class="columns is-multiline">

                        <div class="column is-full " v-for="(file, index) in chapterFiles" :key="file.title">
                            <b-collapse @open="getVideos(file, index)" :open="false" class="card" aria-id="contentIdForA11y3">
                                <div slot="trigger" class="card-header" role="button" aria-controls="contentIdForA11y3">
                                    <p class="card-header-title">
                                        {{index+1}} &ensp;|&ensp; {{file.title}}
                                    </p>
                                    <a class="card-header-icon">

                                        <i v-if="file.fileType == 'video' " style="color:red" class="fab fa-youtube"></i>
                                        <i v-else style="color:#bf2828" class="fas fa-file-pdf"></i>
                                    </a>
                                </div>
                                <div class="card-content">
                                    <div class="content">

                                        <center>
                                            <!-- <pdf v-if="file.fileType == 'pdf'" :src="file.url">

                                            </pdf> -->
                                            <a v-if="file.fileType == 'pdf'" :href="file.url" target="_blank" rel="noopener noreferrer">Click Here to view PDF</a>
                                            <!-- <iframe v-if="file.fileType == 'video'" :src="file.url" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe> -->

                                            <div v-if="file.fileType == 'video'" ref="myDiv" class="has-background-gray" id="embedBox" style="max-width:100%;height:auto;border-radius:6px;">
                                                
                                            </div>
                                            <!-- <youtube v-if="file.fileType == 'video'" player-width="340" player-height="207" :video-id="videoId(file.url)"></youtube> -->
                                        </center>

                                    </div>
                                </div>
                                <footer class="card-footer">

                                    <a class="card-footer-item" @click="fileModal(file)">Edit</a>
                                    <a class="card-footer-item" @click="deleteFile(file)">Delete</a>
                                </footer>
                            </b-collapse>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import chapterService from './service';
import Vue2Filters from 'vue2-filters';
// import pdf from 'vue-pdf'
import pdf from 'pdfvuer'

import addFiles from './addFiles'
import addQuiz from './addQuiz'
import Firebase from '../../lib/Firebase'
import {
    getIdFromURL,
    getTimeFromURL
} from 'vue-youtube-embed'
import addModulesVue from './addModules.vue';
import VueJwtDecode from 'vue-jwt-decode'



export default {
    name: 'chapter',
    mixins: [Vue2Filters.mixin],
    components: {
        pdf
    },

    created() {
        this.fetchCities();

    },

    data() {
        return {
            activeTab: 0,
            configs: {
                active: ''
            },
            isLoading: true,
            cities: [],
            dropFiles: [],
            chapterSelected: null,
            searchName: null,
            chapterFiles: null,
            items: null,
            embedDiv: null,
            quizQuestions: null

        };
    },
    mounted() {
        this.embedDiv = document.querySelector("#embedBox");
    },
    methods: {
        getButtonType(a, b) {
            return a != b ? 'is-dark' : 'is-success'
        },
        videoId(url) {
            return getIdFromURL(url)
        },
        fetchCities() {
            chapterService.all().then(cities => {
                this.cities = cities;

                this.isLoading = false;
            });
        },
        fetchVideoId(url){
            let videoId  = VueJwtDecode.decode(url)
            console.log(videoId)
            return videoId

        },
        ischapterSelected(chapter) {
            return this.chapterSelected && this.chapterSelected.docId === chapter.docId;
        },

        changechapterSelected(chapter) {
            this.chapterSelected = chapter;
            chapterService.retriveFiles(chapter).then(files => {
                this.chapterFiles = files;
                console.log(this.chapterFiles)
                this.isLoading = false;
            });
            chapterService.retriveQuestions(chapter).then(questions => {
                this.quizQuestions = questions;
                console.log(this.quizQuestions)
                this.isLoading = false;
            });
            this.$bus.$emit('chapter_CHANGED', chapter);
            this.$buefy.toast.open('Current Chapter updated');
        },

        deleteDropFile(index) {
            this.dropFiles.splice(index, 1)
        },
        deleteFile(fileToDelete) {
            // this.isUsersLoading = true;
            this.$buefy.dialog.confirm({
                message: 'Sure to delete file?',
                onConfirm: () => {
                    chapterService.deleteFile(fileToDelete.docId, this.chapterSelected).then(() => {
                        this.chapterFiles = this.chapterFiles.filter(file => fileToDelete.docId !== file.docId);
                        // this.isUsersLoading = false;
                        this.$buefy.toast.open('File deleted successfully');
                    });
                }
            });
        },
        deleteQuestion(question) {
            // this.isUsersLoading = true;
            this.$buefy.dialog.confirm({
                message: 'Sure to delete question?',
                onConfirm: () => {
                    chapterService.deleteQuestion(question.docId, this.chapterSelected).then(() => {
                        this.chapterFiles = this.quizQuestions.filter(
                            file => question.docId !== file.docId
                        );
                        // this.isUsersLoading = false;
                        this.$buefy.toast.open('Question deleted successfully');
                    });
                }
            });
        },
        openAddchapterDialog(modulee) {

            this.$buefy.modal.open({
                parent: this,
                props: {
                    propModule: modulee,
                },
                component: addModulesVue,
                hasModalCard: true
            });

            // this.$buefy.dialog.prompt({
            //     message: `Enter Module name`,
            //     inputAttrs: {
            //         placeholder: 'e.g. Module 2'
            //     },
            //     onConfirm: value => {
            //         this.isLoading = true;

            //         chapterService.add(value).then(response => {
            //             const newchapter = {
            //                 docId: response.id,
            //                 name: value
            //             };

            //             this.cities.push(newchapter);
            //             this.isLoading = false;
            //             this.$buefy.toast.open({
            //                 message: 'Module Added Successfully',
            //                 type: 'is-success'
            //             });
            //         });
            //     }
            // });
        },

        fileListner() {
            Firebase.firestore().collection("course").doc(this.chapterSelected).collection('files')
                .onSnapshot(function (snapshot) {
                    snapshot.docChanges().forEach(function (change) {
                        if (change.type === "added") {
                            console.log("New city: ", change.doc.data());
                        }
                        if (change.type === "modified") {
                            console.log("Modified city: ", change.doc.data());
                        }
                        if (change.type === "removed") {
                            console.log("Removed city: ", change.doc.data());
                        }
                    });
                });
        },
        quizSave() {

        },
        fileModal(file = null) {
            this.$buefy.modal.open({
                parent: this,
                props: {
                    propFile: file,
                    chapter: this.chapterSelected,
                    array: this.chapterFiles
                },
                component: addFiles,
                hasModalCard: true
            });

        },
        quizModal(question = null) {
            this.$buefy.modal.open({
                parent: this,
                props: {
                    propQuestion: question,
                    chapter: this.chapterSelected,
                    questions: this.quizQuestions
                },
                component: addQuiz,
                hasModalCard: true
            });

        },
        getVideos: function (video, playerIndex) {
            var vm = this;
            console.log(video)
            let vdoBlob = video

            // console.log("Hey this is runnnig")
            // const response = await fetch("https://service.letsupgrade.in/vid", {
            //     method: 'POST',
            //     body: JSON.stringify({
            //         videoId: "a0d9d9530e444db9a634e4f704ca8dc1",
            //         uid: vm.userId,
            //         mobile: vm.user.mobile
            //     }),
            // });
            // const data = await response.json();
            // this.totalVuePackages = data;
            // console.log(this.totalVuePackages)

            console.log("Hwy   ",vm.$refs.myDiv[playerIndex])
            console.log(vdoBlob)
            var video = new VdoPlayer({
                otp: vdoBlob.otp,
                playbackInfo: btoa(JSON.stringify({
                    videoId: vdoBlob.url
                })),
                theme: "b5e5a9020189409db6b7ecb2f762de45",
                plugins: [{
                    name: 'keyboard',
                    options: {
                        preset: 'default',
                        bindings: {
                            'Up': (player) => player.setVolume(player.volume + 0.2),
                            'Down': (player) => player.setVolume(player.volume - 0.2),
                        },
                    }
                }],
                // the container can be any DOM element on website

                container: vm.$refs.myDiv[playerIndex],
            });
            console.log(video)
            // you can directly call any methods of VdoPlayer class from here. e.g:
            // video.addEventListener(`load`, () => {
            //   video.play(); // this will auto-start the video
            //   console.log('loaded');
            // });

        },
    }
};
</script>

<style scoped>
.chapter-container {
    height: 100%;
    display: flex;
    justify-content: space-between;
}

.fileBox {
    height: 100%;
    display: flex;
}

.card-content {
    padding: 0.75rem;
}

.cgapterss {
    -webkit-box-shadow: 0px 0px 0px 0px rgba(255, 255, 255, 0) !important;
    -moz-box-shadow: 0px 0px 0px 0px rgba(255, 255, 255, 0) !important;
    box-shadow: 0px 0px 0px 0px rgba(255, 255, 255, 0) !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/course/course.vue